import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './FormSection.module.css'

function FormSection({ title, children, open: initialOpen }) {
  const [open, setOpen] = useState(initialOpen)

  const handleHeaderClick = event => {
    event.preventDefault()
    setOpen(o => !o)
  }

  const iconClass = classNames('fa', {
    'fa-chevron-down': open,
    'fa-chevron-right': !open,
  })

  return (
    <div>
      <header onClick={handleHeaderClick}>
        <span className={open ? styles.iconOpen : styles.icon}>
          <i className={iconClass} />
        </span>
        <span>{title}</span>
      </header>
      {open && children}
    </div>
  )
}

export default FormSection
